import { createPlateUI } from '@udecode/plate-ui'

export const plateUI = createPlateUI({})
